import { SideEnum } from '@model/enum/side.enum';
import { SidebarService } from '@services/sidebar.service';
import { MarketEnum } from './../../model/enum/market.enum';
import { MessageQuote } from './../../model/webFeeder/message-quote.model';
import { QuoteService } from './../../services/webFeeder/sckt-quotes.service';
import { NotificationsService } from 'angular2-notifications';
import { StatusOmsService } from './../../services/webFeeder/sckt-status-oms.service';
import { StatusConnection } from './../../model/status-connection';
import { TypeOrderEnum } from './../../model/enum/type-order.enum';
import { SimpleOrder } from './../../model/simpleOrder';
import { ConfigService } from './../../services/webFeeder/config.service';
import { PositionService } from './../../services/webFeeder/sckt-position.service';
import { Subscription, of } from 'rxjs';
import { AppUtils } from './../../utils/app.utils';
import { Constants } from './../../utils/constants';
import { BovBmfModel } from './../../dto/custody-model-bov-bmf';
import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { DailyOrderService } from '@services/webFeeder/sckt-daily-order.service';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';
import { MarketTypeEnum } from '@model/enum/market-type.enum';

@Component({
  selector: 'app-trade-chart',
  templateUrl: './trade-chart.component.html'
})
export class TradeChartComponent implements OnInit, OnDestroy {

  @Output() showConfirmation = new EventEmitter<boolean>();
  @Input() data: any;
  @Input() hiddenConfirmationBillet = false;
  @Input() set symbol(value: string) {
    this.currentSymbol = value;
    this.showConfirmationBillit = false;
    this.reset();
    this.setQuote(value);
  }

  @Input() set orderStrategy(value: string) {
    this.model.orderStrategy = value;
  }

  private messageQuote = new MessageQuote();
  private oldSymbolTemp: string;
  private minimumAmount = 0;
  private initialPrice = false;
  public lastTrade: any;
  private currentSymbol: string;
  private intervalAccount: any;
  private subscriptionPositionList: Array<Subscription> = [];
  private subscriptionStatusOms: Subscription;
  private subscriptionQuote: Subscription;
  private msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  private msgOffline = Constants.MSG_OFFLINE_NEGOTIATION_02;
  private msgQuoteInvalid = Constants.WORKSPACE_MSG005;
  padWarning = Constants.MSG_TRADE_CHART_PAD_WARNING;
  gridColumnWidth = Constants.GRID_COL_WIDTH;
  cancelTooltip = Constants.TOOLTIP_CANCEL;
  listPosition = new BovBmfModel();
  showConfirmationBillit = false;
  isLoggedNegotiation: boolean;
  model = new SimpleOrder();
  showWarningMessage = true;
  statusOmsOnline: boolean;
  termOperator: boolean;
  indiceFuture: boolean;
  messageAccept = false;
  loading = false;
  qtdValid = true;
  price: any;
  priceValuesFormatOptions = Constants.PRICE_VALUES_FORMAT_OPTIONS;
  priceValuesFormatOptionsFuture = Constants.PRICE_VALUES_FORMAT_OPTIONS_FUTURES;

  constructor(
    private _positionService: PositionService,
    private _configService: ConfigService,
    private _statusOmsService: StatusOmsService,
    public _notificationService: NotificationsService,
    private cdRef: ChangeDetectorRef,
    private _quoteService: QuoteService,
    private _sidebarService: SidebarService,
    private _dailyOrderService: DailyOrderService,
  ) {
    this.subscriptionOms();
    this.model.qtd = 0;
    this.model.orderStrategy = 'Daytrade';
    this.model.timeInForce = 'DAY';
    this.model.type = TypeOrderEnum.MARKET;
    this.model.validityOrder = new Date();
    this.model.stoptrigger = 0;
    this.model.stoplimit = 0;
    this.model.targettrigger = 0;
    this.model.targetlimit = 0;
    this.model.minimumIncrement = '0.01';
    if (this._configService.getHbSignature()) {
      this.model.signature = this._configService.getHbSignature();
    }
    this._configService.changeAccountBillet$.subscribe(res => {
      if (res) {
        this.changeAccount(res);
      }
    });
  }

  ngOnInit() {
    if (this.currentSymbol) {
      this.model.quote = this.currentSymbol;
      this.setQuote(this.currentSymbol);
    }
    this._configService.authHbLogged$.subscribe(loggedNegotiation => {
      if (loggedNegotiation) {
        this.isLoggedNegotiation = true;
        this.getAccount();
      } else {
        this.isLoggedNegotiation = false;
        this.loading = false;
        this.termOperator = false;
        this.showConfirmationBillit = false;
        this.showConfirmation.emit(false);
        this.unsubscribeSocket();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribeScktPosition(true);
    this.unsubscribeQuote();
    this.unsubscribeSocket();
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
  }

  verifyQuantity() {
    if (this.model.price < 0) {
      this.model.price = this.model.price * -1;
    }
    if (this.model.qtd < 0) {
      this.model.qtd = this.model.qtd * -1;
    }
    this.qtdValid = this.model.qtd < this.minimumAmount ? false : true;
    this.model.total = (this.model.price * this.model.qtd) / (AppUtils.convertNumberAux(this.messageQuote.quotationForm as any) * AppUtils.convertNumberAux(this.messageQuote.contractMultiplier as any))
  }

  validPrice(value: number) {
    if (value < 0) {
      return this.model.price = this.model.price * -1;
    }
    if (this.model.price > 999999) {
      return this.model.price = 999999;
    } else if (this.model.maxfloor > 9999999) {
      return this.model.maxfloor = 9999999;
    } else if (this.model.minqtd > 999999) {
      return this.model.minqtd = 999999;
    } else if (this.model.qtd > 999999) {
      return this.model.qtd = 999999;
    }
  }

  quantityDisabled() {
    return this.model.quote == null ? false : true;
  }

  confirmTradeAction(options: { side: SideEnum, qtd?: number }) {
    if (!options.side) {
      return;
    }
    this.model.side = options.side;
    if (options.qtd) {
      this.model.qtd = options.qtd;
    }
    this.showConfirmationBillit = true;
    this.showConfirmation.emit(true);
  }

  openModalConfirm(value) {
    if (!this.validLoggedNegotiation()) {
      return;
    }
    if (!this.statusOmsOnline) {
      this._notificationService.alert('', this.msgStatusOmsOffile);
      return;
    }
    if (value) {
      this.model.type = value.isMarket ? TypeOrderEnum.MARKET : TypeOrderEnum.LIMITED;
      this.model.side = value.side;
      if (!this.hiddenConfirmationBillet) {
        this.showConfirmationBillit = true;
      }
    } else {
      this.showConfirmationBillit = false;
    }
    if (!this.hiddenConfirmationBillet) {
      this.showConfirmation.emit(this.showConfirmationBillit);
    } else {
      this._dailyOrderService.verifyEletronicSignature(TypeOrderRequestEnum.SEND_ORDER, this.model);
    }
  }

  closeModalConfirm(value) {
    this.showConfirmationBillit = value;
  }

  validLoggedNegotiation() {
    if (!this.model.quote) {
      this._notificationService.warn('', this.msgQuoteInvalid);
      return false;
    } else if (!this.isLoggedNegotiation) {
      this._notificationService.warn('', this.msgOffline);
      this._sidebarService._clickOpenTabLoginBroker.next(true);
      return false;
    }
    return true;
  }

  subscriptionOms() {
    this.subscriptionStatusOms = this._statusOmsService.messagesStatusOms
      .subscribe(statusOms => {
        if (statusOms && statusOms === StatusConnection.ERROR) {
          this.loading = false;
          this.statusOmsOnline = false;
          this._notificationService.warn('', this.msgStatusOmsOffile);
          setTimeout(() => {
            if (this.cdRef) {
              this.cdRef.detectChanges();
            }
          }, 500);
        } else {
          this.statusOmsOnline = true;
          setTimeout(() => {
            if (this.cdRef) {
              this.cdRef.detectChanges();
            }
          }, 500);
        }
      });
  }

  unSubscriptionOms() {
    if (this.subscriptionStatusOms) {
      this.subscriptionStatusOms.unsubscribe();
    }
  }

  unsubscribeSocket() {
    this.unSubscriptionOms();
    this.unsubscribeScktPosition();
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
  }

  setQuote(symbol: string) {
    const oldSymbol = this.model.quote;
    this.oldSymbolTemp = oldSymbol;
    symbol = AppUtils.trimStart(symbol);
    this.model.quote = symbol;

    if (
      this.oldSymbolTemp &&
      this.model.quote &&
      this.oldSymbolTemp.toLowerCase() === this.model.quote.toLowerCase() &&
      this.subscriptionQuote
    ) {
      return;
    }

    if (
      this.model.quote === '-' ||
      this.model.quote === '' ||
      this.model.quote.toLowerCase() === 'invalid'
    ) {
      this.reset();
      this.model.quote = '';
      return;
    }
    this.priceValuesFormatOptions.precision = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
      this.messageQuote.tickSize ? this.messageQuote.tickSize : 2;
    this.priceValuesFormatOptionsFuture.precision = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
      this.messageQuote.tickSize ? this.messageQuote.tickSize : 0;
    this.initialPrice = true;
    const msgItem = this._quoteService.subscribeQuote(this.model.quote, Constants.WINDOW_NAME_TRADE_CHART);
    if (msgItem !== undefined && msgItem !== '') {
      this.reset();
      return;
    }

    this.subscriptionQuote = this._quoteService.messagesQuote.subscribe((msg: MessageQuote) => {
      if (msg && msg.errorMessage && (this.model.quote && msg.symbol.toLowerCase() === this.model.quote.toLowerCase())) {
        this.model.quote = null;
        this.model.company = null;
        this._quoteService.unsubscribeQuote(msg.symbol.toLowerCase(), Constants.WINDOW_NAME_TRADE_CHART);
        this.loading = false;
        this.reset();
      } else if (msg !== undefined && msg.symbol != null && msg.symbol === this.model.quote) {
        this.messageQuote = msg;
        this.model.quotationForm = AppUtils.convertNumberAux(msg.quotationForm);
        this.model.contractMultiplier = AppUtils.convertNumberAux(msg.contractMultiplier);

        if (this.model.account && this.subscriptionPositionList.length === 0 && (this.messageQuote.marketType === 1 || this.messageQuote.marketType === 3)) {
          this.subscribeScktPosition();
        }
        this.model.minimumIncrement = !this.messageQuote.minimumIncrement ? '0.01' : this.messageQuote.minimumIncrement.toString().replace(',', '.');
        this.model.priceTickSize = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
          this.messageQuote.tickSize ? this.messageQuote.tickSize : 2;
        if (this.initialPrice) {
          this.indiceFuture = this.messageQuote.symbol.indexOf('win') === 0 || this.messageQuote.symbol.indexOf('dol') === 0
            || this.messageQuote.symbol.toLowerCase().indexOf('ind') === 0 ? true : false;
          this.minimumAmount = this.messageQuote.minimumIncrement ? this.messageQuote.minimumIncrement : 1;
          this.model.loteDefault = this.messageQuote.loteDefault ? this.messageQuote.loteDefault : 100;
          if (this.messageQuote.lastTrade &&
            (this.messageQuote.lastTrade.toString() !== '-' && this.messageQuote.lastTrade.toString() !== '0,00' && this.messageQuote.lastTrade.toString() !== '0')) {
            const lastTradeTemp = this.messageQuote.lastTrade.toString().replace('.', '');
            const lastTradeNumber = AppUtils.convertNumber(lastTradeTemp);
            this.messageQuote.lastTrade = AppUtils.convertToNumber(lastTradeNumber.toString(), this.model.priceTickSize);
            this.lastTrade = AppUtils.convertNumberToCurrency(Number(this.messageQuote.lastTrade), this.model.priceTickSize);
            this.model.price = lastTradeNumber;
            this.price = AppUtils.convertNumberToCurrency(this.lastTrade, this.model.priceTickSize);
          } else {
            if (this.messageQuote.lastTrade &&
              (this.messageQuote.lastTrade.toString() === '-' || this.messageQuote.lastTrade.toString() === '0,00' || this.messageQuote.lastTrade.toString() === '0')) {
              this.messageQuote.lastTrade = this.messageQuote.previous;
              const value = this.messageQuote.lastTrade.toString().trim().replace('.', '').replace(',', '.');
              this.lastTrade = AppUtils.convertNumberToCurrency(Number(value), this.model.priceTickSize);
              this.model.price = Number(value);
            } else {
              this.lastTrade = 0;
              this.model.price = this.lastTrade;
            }
          }
          if (this.messageQuote.description && this.messageQuote.description !== '' && this.messageQuote.marketType === Constants.MARKET_CODE_BOVESPA) {
            this.model.company = this.messageQuote.description + ' ' + this.messageQuote.classification;
          } else {
            this.model.company = this.messageQuote.description;
          }
          this.model.qtd = this.model.loteDefault > 0 ? this.model.loteDefault : 0;
          this.model.market = this.messageQuote.marketType;
          this.initialPrice = false;
        }
        this.price = AppUtils.convertNumberToCurrency(this.lastTrade, this.model.priceTickSize);
      }
      this.verifyQuantity();
    });
  }

  reset() {
    if (!this.model.quote) {
      return;
    }
    const oldSymbol = this.model.quote;
    if (this.data && oldSymbol.toLowerCase() === this.data.symbol.toLowerCase()) {
      return;
    }
    this.unsubscribeQuote();
    this.unsubscribeScktPosition();
    this.listPosition = new BovBmfModel();
    this.price = null;
    this.lastTrade = null;
    this.messageQuote = new MessageQuote();
    this.model.minqtd = 0;
    this.model.price = 0;
    this.model.qtd = 0;
    this.minimumAmount = 0;
    this.qtdValid = true;
    this.priceValuesFormatOptions.precision = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
      this.messageQuote.tickSize ? this.messageQuote.tickSize : 2;
    this.priceValuesFormatOptionsFuture.precision = this.messageQuote.tickSize && this.messageQuote.marketType && this.messageQuote.marketType === MarketEnum.BITCOIN ? 3 :
      this.messageQuote.tickSize ? this.messageQuote.tickSize : 0;
    this.verifyQuantity();
  }

  changeAccount(account: string) {
    this.unsubscribeScktPosition(true);
    if (account) {
      this.model.account = account;
      this._configService.writeLog(Constants.WINDOW_NAME_TRADE_CHART + ' > changeAccount: ' + this.model.account);
      this.subscribeScktPosition();
    }
  }

  getAccount() {
    this.intervalAccount = setInterval(() => {
      this.model.account = this._configService.getBrokerAccountSelected();
      if (this.model.account) {
        clearInterval(this.intervalAccount);
        if (this.model.account && this.subscriptionPositionList.length === 0 && this.messageQuote.marketType) {
          this.subscribeScktPosition();
        }
      } else {
        this.isLoggedNegotiation = false;
        this.loading = false;
        this.termOperator = false;
        this.showConfirmationBillit = false;
        this.showConfirmation.emit(false);
        this.unsubscribeSocket();
      }
    }, 1000);
  }

  subscribeScktPosition() {
    this.loading = false;
    const initialSubscription = this._positionService.subscribePosition(this.model.account, Constants.WINDOW_NAME_TRADE_CHART)
      .subscribe(data => {
        if (data) {
          Object.keys(data).forEach(element => {
            const positionToUpdate = data[element].find((position: any) => (
              position.marketCode === MarketTypeEnum.BOVESPA && this.model.quote.substring(this.model.quote.length - 1).toUpperCase() === 'F'
                ? this.model.quote.substring(0, this.model.quote.length - 1).toUpperCase() === position.quote.toUpperCase()
                : this.model.quote.toUpperCase() === position.quote.toUpperCase()));
            if (positionToUpdate) {
              this.updatePositionQuote(positionToUpdate);
            }
          });
        }
      });

    const messagesSubscription = this._positionService.messagesPosition
      .subscribe(data => {
        const positionToUpdate = data.find((position: any) => (
          position.marketCode === MarketTypeEnum.BOVESPA && this.model.quote.substring(this.model.quote.length - 1).toUpperCase() === 'F'
            ? this.model.quote.substring(0, this.model.quote.length - 1).toUpperCase() === position.quote.toUpperCase()
            : this.model.quote.toUpperCase() === position.quote.toUpperCase()));
        if (positionToUpdate) {
          this.updatePositionQuote(positionToUpdate);
        }
      });

    this.subscriptionPositionList.push(initialSubscription, messagesSubscription);
  }

  updatePositionQuote(position) {
    if (!position) {
      return;
    }
    this.listPosition = position;
  }

  unsubscribeScktPosition(forceUnsubscribe?: boolean) {
    if (this._positionService && this.model.account) {
      this._positionService.unsubscribePosition(this.model.account, Constants.WINDOW_NAME_TRADE_CHART, forceUnsubscribe);
      this.subscriptionPositionList.forEach(subscription => subscription.unsubscribe());
      this.subscriptionPositionList = [];
      this.listPosition = new BovBmfModel();
    }
    if (this.intervalAccount) {
      clearInterval(this.intervalAccount);
    }
  }

  unsubscribeQuote() {
    if (this.subscriptionQuote) {
      this.subscriptionQuote.unsubscribe();
    }
    if (this._quoteService) {
      this._quoteService.unsubscribeQuote(this.model.quote, Constants.WINDOW_NAME_TRADE_CHART);
    }
  }

  close() {
    if (this.termOperator || this.showConfirmationBillit) {
      this.termOperator = false;
      this.showConfirmationBillit = false;
      this.showConfirmation.emit(false);
    }
  }

  setLoading(value) {
    this.loading = value;
  }

  openModalTermOperator(value) {
    this.termOperator = value;
  }

}
